import React,{useState} from 'react';
import {Link} from 'react-router-dom';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
//import Snackbar from '@material-ui/core/Snackbar';

import {signup} from './../../services/firebase';

function SignUp(props) {

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  
  const handleSubmit = (evt) => {
    evt.preventDefault();
    

    if(name && email && password && confirmPassword){
      if(password===confirmPassword){
        
        signup(email, password)
        .then(user =>{
          console.log('se registro');
              //props.setAuthentication(true);
              sessionStorage.setItem('user',user.user.uid);       
                             
                  
        })
        .catch(err=>{
          
            console.log('ocurrio un error');
            console.log(err);
            setPassword('');
            setConfirmPassword('');
            
            
        });
      }else{
        console.log('contraseñas distintas');
        setPassword('');
        setConfirmPassword('');
      }
    }else{

      setPassword('');
      setConfirmPassword('');
    }
  };

 /* const handleClose = () => {
    setOpen(false);
  };*/

  
  return (
     <Container component="main" maxWidth="xs" className="prueba" >
     
      <Container className="fondo" >
        <Grid className="imagen" justify="center" >
      <img src="logo3.png"></img>
        </Grid>
        
        <Grid>
          <form  onSubmit={handleSubmit}>
              <Grid container spacing={2}>
              
                <Grid item xs={12} sm={12}>
                  <Typography component="h1" variant="h5">
                    Crea tu cuenta
                  </Typography>
                </Grid>        
          
                <Grid item xs={12} sm={12}>
                  <TextField
                    autoComplete="fname"
                    name="name"
                    variant="outlined"
                    required
                    fullWidth
                    id="name"
                    label="Nombre"
                    autoFocus           
                    value={name}
                    onChange={e => setName(e.target.value)}
                
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    id="email"
                    label="Correo"
                    name="email"
                    autoComplete="email"           
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                
                  />
                </Grid>
          
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    name="password"
                    label="Contraseña"
                    type="password"
                    id="password"           
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                
                  />
                </Grid>
          
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    name="confirmPassword"
                    label="Confirmar contraseña"
                    type="password"
                    id="confirmPassword"           
                    value={confirmPassword}
                    onChange={e => setConfirmPassword(e.target.value)}
                
                  />
                </Grid>
          
                
                <Grid item xs={12}>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className="button"
              >
                Sign Up
              </Button>
              </Grid>
              
                <Grid item xs={12}>
                  <Typography component="p">¿Ya tienes cuenta? <Link to="/">¿Inicia sesión?</Link></Typography>
                </Grid>
                      </Grid>
      </form>

   </Grid>
   </Container>
    
  </Container>
  );
}

export default SignUp;
